import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Generates a downloadable PDF invoice for a seller order.
export const generateInvoice = (order, opts = {}) => {
  const doc = new jsPDF();
  const orange = [234, 88, 12];
  const money = (n) => `EUR ${Number(n || 0).toFixed(2)}`;

  doc.setFillColor(...orange);
  doc.rect(0, 0, 210, 22, "F");
  doc.setTextColor(255);
  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.text("Xurray Mart", 14, 14);
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text("INVOICE", 196, 14, { align: "right" });

  doc.setTextColor(30);
  doc.setFontSize(11);
  doc.text(`Invoice #: ${order.order_id.slice(-10).toUpperCase()}`, 14, 34);
  doc.text(`Date: ${new Date(order.created_at).toLocaleDateString()}`, 14, 40);
  doc.text(`Status: ${(order.fulfillment_status || order.status || "processing").toUpperCase()}`, 14, 46);

  const addr = order.shipping_address;
  doc.setFont(undefined, "bold");
  doc.text("Bill to:", 130, 34);
  doc.setFont(undefined, "normal");
  doc.text(order.customer_name || "Customer", 130, 40);
  if (order.customer_email) doc.text(order.customer_email, 130, 46);
  if (addr) {
    doc.text(`${addr.line1 || ""}`, 130, 52);
    doc.text(`${addr.city || ""} ${addr.postal_code || ""}`, 130, 58);
    doc.text(`${addr.country || ""}`, 130, 64);
  }

  const items = order.items || [];
  autoTable(doc, {
    startY: 72,
    head: [["Product", "Qty", "Unit price", "Amount"]],
    body: items.map((it) => [
      it.title || "Item",
      String(it.quantity || 1),
      money(it.price || 0),
      money((it.price || 0) * (it.quantity || 1)),
    ]),
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: orange, textColor: 255 },
    columnStyles: { 1: { halign: "center" }, 2: { halign: "right" }, 3: { halign: "right" } },
    margin: { left: 14, right: 14 },
  });

  const subtotal = order.seller_total ?? items.reduce((s, it) => s + (it.price || 0) * (it.quantity || 1), 0);
  let y = doc.lastAutoTable.finalY + 8;
  doc.setFont(undefined, "bold");
  doc.text("Total:", 150, y);
  doc.text(money(subtotal), 196, y, { align: "right" });

  doc.setFont(undefined, "normal");
  doc.setFontSize(8);
  doc.setTextColor(130);
  doc.text("Thank you for shopping with Xurray Mart — African products, delivered across Europe.", 14, 285);

  doc.save(`invoice_${order.order_id.slice(-8)}.pdf`);
};
